import React from 'react';

type Props = {
  children: React.ReactNode,
}

const ModalBody = (props: Props) => {
  const { children } = props;

  return (
    <div className="modal-body">
      {children}
    </div>
  );
};

export default ModalBody;
